import script from "./MessageSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./MessageSettingsModal.vue?vue&type=style&index=0&id=008315a0&lang=scss"

const __exports__ = script;

export default __exports__